export function getRootDomain(hostname: string): string | null {
  if (!hostname || hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) return null;
  const parts = hostname.split('.');
  return parts.length >= 2 ? parts.slice(-2).join('.') : null;
}

export function isSameRootDomain(url1: string, url2: string): boolean {
  try {
    const first = getRootDomain(new URL(url1).hostname);
    const second = getRootDomain(new URL(url2).hostname);
    return first !== null && first === second;
  } catch {
    return false;
  }
}
